export const merchantProfile = {
  name: 'TUR DER HOFFNUNG',
  website: 'https://turderhoffnung.com',
  address: '50 Rawdon Street, Freetown, Sierra Leone',
  tin: '1001205375',
  companyNo: 'SL280624TURDE22311',
  statement:
    'Card details are processed securely via MPGS Hosted Checkout. TUR DER HOFFNUNG does not store card numbers, CVV or expiry dates.',
};

export const sampleTransaction = {
  customerName: 'John Doe',
  customerEmail: 'john@example.com',
  customerPhone: '+23270000000',
  service: 'Digital Service Payment',
  referenceNumber: 'TDH-20260611-000001',
  amount: '100.00',
  currency: 'USD',
  paymentReference: 'Pending MPGS sandbox transaction',
  gatewayTransactionId: 'Pending MPGS sandbox transaction',
  dateLong: '11 June 2026',
  dateShort: '11.06.2026',
};

export const paymentLogRows = [
  {
    refNo: 'TDH-20260611-000001',
    customerName: 'John Doe',
    customerEmail: 'john@example.com',
    service: 'Digital Service Payment',
    amount: '100.00',
    currency: 'USD',
    status: 'SUCCESS',
    gatewayTransactionId: 'Pending sandbox',
    createdDate: '11 June 2026',
    updatedDate: '11 June 2026',
  },
  {
    refNo: 'TDH-20260611-000002',
    customerName: 'Jane Smith',
    customerEmail: 'jane@example.com',
    service: 'Digital Service Payment',
    amount: '75.00',
    currency: 'USD',
    status: 'FAILED',
    gatewayTransactionId: 'Pending sandbox',
    createdDate: '11 June 2026',
    updatedDate: '11 June 2026',
  },
  {
    refNo: 'TDH-20260611-000003',
    customerName: 'Michael Brown',
    customerEmail: 'michael@example.com',
    service: 'Digital Service Payment',
    amount: '50.00',
    currency: 'USD',
    status: 'PENDING',
    gatewayTransactionId: 'Pending sandbox',
    createdDate: '11 June 2026',
    updatedDate: '11 June 2026',
  },
];

export const paymentStatusRows = [
  {
    refNo: 'TDH-20260611-000001',
    initialStatus: 'INITIATED',
    currentStatus: 'SUCCESS',
    lastGatewayResponse: 'Approved / Pending real MPGS response',
    updatedAt: '11 June 2026',
  },
  {
    refNo: 'TDH-20260611-000002',
    initialStatus: 'INITIATED',
    currentStatus: 'FAILED',
    lastGatewayResponse: 'Insufficient Funds / Pending real MPGS response',
    updatedAt: '11 June 2026',
  },
  {
    refNo: 'TDH-20260611-000003',
    initialStatus: 'INITIATED',
    currentStatus: 'PENDING',
    lastGatewayResponse: 'Awaiting gateway response',
    updatedAt: '11 June 2026',
  },
];

export const reconciliationRows = [
  {
    date: '11 June 2026',
    refNo: 'TDH-20260611-000001',
    gatewayTransactionId: 'Pending sandbox',
    customer: 'John Doe',
    amount: '100.00',
    currency: 'USD',
    paymentStatus: 'SUCCESS',
    settlementStatus: 'Pending Settlement',
    notes: 'Awaiting GTBank settlement report',
  },
  {
    date: '11 June 2026',
    refNo: 'TDH-20260611-000002',
    gatewayTransactionId: 'Pending sandbox',
    customer: 'Jane Smith',
    amount: '75.00',
    currency: 'USD',
    paymentStatus: 'FAILED',
    settlementStatus: 'Not Settled',
    notes: 'Failed transaction',
  },
  {
    date: '11 June 2026',
    refNo: 'TDH-20260611-000003',
    gatewayTransactionId: 'Pending sandbox',
    customer: 'Michael Brown',
    amount: '50.00',
    currency: 'USD',
    paymentStatus: 'PENDING',
    settlementStatus: 'Pending',
    notes: 'Awaiting gateway response',
  },
];
